import { BREAK_POINTS } from '../settings';

export default function () {
	let elTables = document.querySelectorAll('.c-article__body table');

	if(elTables.length > 0) {
		[].forEach.call(elTables, function(el) {
			var div = document.createElement("div");
			div.className = 'c-table-wrap js-scrollable';
			el.before(div);
			div.append(el);
		})

		if ( window.innerWidth < BREAK_POINTS.gtTAB) {
			new ScrollHint('.js-scrollable');
		}
	}
}